import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class FlushDatasetCache extends React.Component
{
    constructor(props)
    {
        super(props);

        this.params = this.props.router.params;
        
        this.user = this.props.auth.user;
        
        this.state = {
            user: this.user,
        };
        
        this.flushDatasetCache = this.flushDatasetCache.bind(this);
    }

    flushDatasetCache()
    {
        //console.log('DatasetDelete');
        var this_component = this;

        if( !(`id` in this_component.props) || this_component.props.id==0 ) { console.log('flushDatasetCache Undefined value for `id`'); return false; }

        monday.execute("confirm", {
            message: "Confirm that you want to clear a Data Source cache",
            confirmButton: "Clear", 
            cancelButton: "Cancel", 
            excludeCancelButton: false
        }).then((res) => {

            //console.log('Confirm dialog',res.data);

            if(res.data.confirm == true)
            {
                var data = new FormData();
                data.append('id', this_component.props.id);
                
                
                var moveEvent = new CustomEvent('beforeFlushDatasetCache', { 
                    detail: { },
                    bubbles: true,
                    composed: true,
                });
                ReactDOM.findDOMNode(this_component).dispatchEvent(moveEvent);
                
                var url = '/api/v1/dataset/flushcache';
                
                axios.post(url, data)
                    .then(response => {

                        if(response.data.error==0)
                        {

                            monday.execute("notice", { 
                                message: 'Data Source cache cleared successfully',
                                type: "success", // or "error" (red), or "info" (blue)
                                timeout: 10000,
                            });

                            
                            var moveEvent = new CustomEvent('afterFlushDatasetCache', {
                                detail: { },
                                bubbles: true,
                                composed: true,
                            });
                            ReactDOM.findDOMNode(this_component).dispatchEvent(moveEvent);
                            
                        }
                    })
                    .catch(error => {
                        console.log('flushDatasetCache error', error, error.response);

                        if('error_message' in error.response.data)
                        {
                            monday.execute("notice", { 
                                message: error.response.data.error_message,
                                type: "error", // or "error" (red), or "info" (blue)
                                timeout: 30000,
                            });
                        }
                        
                        var moveEvent = new CustomEvent('errorFlushDatasetCache', { 
                            detail: { },
                            bubbles: true,
                            composed: true,
                        });
                        ReactDOM.findDOMNode(this_component).dispatchEvent(moveEvent);
                        
                    });
            }

        });
    }
    
    render()
    {
        var this_component = this;

        return (<div style={this_component.props.style}></div>);
    }
}

FlushDatasetCache.defaultProps = {
    style: {'display': 'none'}
};

export default withRouter(withAuth(FlushDatasetCache));
